export default "__VITE_ASSET__Cib_oRNB__"